<template>
    <div class="date-picker-widget">
        <div class="widget-header app-blue-gradient-bg">
            <h3>{{ steps[step].title || 'Date Picker' }}</h3>
            <div class="svg-container widget-close-button" @click="closeWidget">
                <widget-close-svg />
            </div>
        </div>
        <div class="content-wrapper">
            <div class="input-container">
                <date-time-selector id="date-time-selector" @dateSelected="setDate" @timeSelected="setDateTime" @dateRemoved="removeDate" @timeRemoved="removeDateTime" />
            </div>
            <div class="scheduled-in-past-container" v-show="isTimeInPast">
                <strong class="red-accent">Selected time is in the past.</strong>
            </div>    
        </div>
        <div class="widget-footer">
            <div class="cancel-container">
                <app-button class="transparent-btn" :onClick="closeWidget">
                    Cancel
                </app-button>
            </div>
            <div class="action-container">
                <app-button :onClick="steps[step].action" :disabled="!hasFullDate" :loading="steps[step].loading">
                    {{ steps[step].buttonText }}
                </app-button>
            </div>
        </div>
    </div>
</template>

<script>
const AppButton = () => import('@/components/common/app-button.vue');
const DateTimeSelector = () => import('@/components/common/date-time-selector.vue');
const WidgetCloseSvg = () => import('@/components/svg/quick-add/widget-close-svg.vue');

import Multiselect from 'vue-multiselect';
import EventBus from '@/scripts/event-bus.js';

export default {
    name: 'date-picker-widget',

    components: {
        'app-button': AppButton,
        'date-time-selector': DateTimeSelector,
        'widget-close-svg': WidgetCloseSvg,
        'multiselect': Multiselect
    },

    props: {
        widget: {
            type: Object,
            required: true
        }
    },

    data() {
        return {
            date: null,
            time: null,
            searching: false,
            step: null,

            steps: {
                addDate: {
                    title: 'Add Date',
                    buttonText: 'Add Date',
                    action: this.addDate,
                    loading: false
                }
            }
        }
    },

    computed: {
        clientId() {
            return this.$store.state.context.client.id;
        },

        routeBaseUrl() {
            return this.$store.getters.routeBaseUrl;
        },

        dueDate() {
            if (this.date && this.time) {
                return `${ this.date }T${ this.time }`;
            } else if (this.date && !this.time) {
                return this.date + 'T08:00:00';
            } else if (!this.date && this.time) {
                return `${ this.$moment().add(1, 'days').format('YYYY-MM-DD') }T${ this.time }`;
            } else {
                return `${ this.$moment().add(1, 'days').startOf('day').add(8, 'hours').format()}`;
            }
        },

        hasFullDate() {
            return this.date && this.time;
        },

        isTimeInPast() {
            var isInPast = false;

            if(this.dueDate) {
                var rightNow = this.$moment();
                var date = this.$moment(this.dueDate);
                var dateDifferenceInSeconds = this.$moment.duration(date.diff(rightNow)).asSeconds();

                isInPast = dateDifferenceInSeconds < 0;
            }

            return isInPast;
        }
    },

    methods: {
        setDate(date) {
            this.date = date;
        },

        removeDate(date) {
            this.date = null;
        },

        setDateTime(time) {
            this.time = time;
        },

        removeDateTime(time) {
            this.time = null;
        },
        
        addDate() {
            EventBus.$emit('add-date', this.dueDate);
            this.closeWidget();
        },

        closeWidget() {
            EventBus.$emit('close-widget', this.widget);
        }
    },

    created() {
        this.step = 'addDate';
    }
}
</script>

<style>
.date-picker-widget .form-group--error .error {
    font-size: 12px;
    color: #C00;
    margin-top: 2px;
}

.date-picker-widget .multiselect .multiselect__tags {
    border: none;
    border-radius: 0;
    border-bottom: 2px solid #E9E9EF;
}

.date-picker-widget .multiselect:hover:not(.multiselect--active) .multiselect__tags {
    border-color: #877D88;
}

.date-picker-widget .multiselect--active .multiselect__tags {
    border-bottom: 3px solid #18AEFF;
}

.date-picker-widget .multiselect .multiselect__single {
    color: #382153;
    font-size: 16px;
}

.date-picker-widget .multiselect .multiselect__select::before {
    color: #F30070;
    border-color: #F30070 transparent transparent;
    border-width: 7px 7px 0;
}

.date-picker-widget .action-container {
    display: flex;
}

.date-picker-widget .action-container .btn {
    margin-left: 15px;
}

.date-picker-widget .cancel-container .btn.transparent-btn {
    background: transparent;
    color: #877D88;
}

.date-picker-widget .cancel-container .btn.transparent-btn:hover {
    background: #E1E0E5;
}

.date-picker-widget .action-container .btn.white-btn {
    background: #FFFFFF;
    color: #877D88;
    border: 2px solid #E9E9EF;
}

.date-picker-widget .scheduled-in-past-container {
    margin-top: 25px;
}


.date-picker-widget .widget-header.app-blue-gradient-bg {
	background: rgb(80,82,254);
    background: -webkit-gradient(linear, left top, right top, from(rgba(80,82,254,1)), to(rgba(75,201,254,1)));
    background: linear-gradient(90deg, rgba(80,82,254,1) 0%, rgba(75,201,254,1) 100%);
}
</style>
